import { render, staticRenderFns } from "./NoshiSelector.vue?vue&type=template&id=7d68b6ca&lang=pug&"
import script from "./NoshiSelector.vue?vue&type=script&lang=ts&"
export * from "./NoshiSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports